var _style, _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,256C0,114.6,114.6,0,256,0s256,114.6,256,256"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.8,133.6c0-37.3,26.2-68.5,61.2-76.1c-5.4-1.2-11-1.8-16.7-1.8c-43,0-77.9,34.9-77.9,77.9 s34.9,77.9,77.9,77.9c5.7,0,11.3-0.6,16.7-1.8C182,202,155.8,170.9,155.8,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,61.2l5.5,17h17.9l-14.5,10.5l5.5,17L256,95.2l-14.5,10.5l5.5-17l-14.5-10.5h17.9L256,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.6,94.6l5.5,17H236l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L212.6,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.4,94.6l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17L276,111.6h17.9L299.4,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.7,144.7l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L282.7,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.3,144.7l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L229.3,144.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/sg.f0419a2e1753b870bcfd47f1fbc07fea.svg";
export { ForwardRef as ReactComponent };